/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const filter_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M9.5 20h12m-12 0a2.5 2.5 0 0 1-5 0m5 0a2.5 2.5 0 0 0-5 0m0 0h-2m17-8h2m-2 0a2.5 2.5 0 0 1-5 0m5 0a2.5 2.5 0 0 0-5 0m0 0h-12m10-8h9m-9 0a2.5 2.5 0 0 1-5 0m5 0a2.5 2.5 0 0 0-5 0m0 0h-5"
    />
  </svg>
)
export default filter_medium
